import classNames from 'classnames'

import Loader from '../../common/loader/Loader'

import classes from './CertificationLoader.module.scss'

const CertificationLoader = () => (
  <main className={classNames('d-flex align-items-center justify-content-center', classes.loader)}>
    <Loader />
  </main>
)

export default CertificationLoader
